<template>
    <div v-if="homeOffer2 && homeOffer2.length">
      <VueSlickCarousel v-bind="settings">
        <div
          id="carousel-home-middle"
          class="containers-image text-center"
          v-for="(image, index) in homeOffer2"
          :key="index"
        >
          <img class="image" :src="image.url.fileUrl" />
        </div>
      </VueSlickCarousel>
    </div>
  </template>
  
  <script>
  import { mapActions, mapState } from "vuex";
  import VueSlickCarousel from "vue-slick-carousel";
  import "vue-slick-carousel/dist/vue-slick-carousel.css";
  import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
  
  export default {
    name: "home-offer-middle",
    components: { VueSlickCarousel },
    data() {
      return {
        settings: {
          arrows: true,
          dots: false,
          autoplay: true,
          autoplaySpeed: 3000,
          slidesToShow: 3,
          touchMove: true,
        },
      };
    },
    computed: {
      ...mapState({
        homeOffer2: ({ advertisement }) => advertisement.homeOffer2,
      }),
    },
    methods: {
      ...mapActions({
        fetchhomeScreenOffer1Data2: "advertisement/homeScreenOffer2",
      }),
    },
  
    mounted() {
      this.fetchhomeScreenOffer1Data2();
    },
  };
  </script>
  
  <style scoped>
  .containers-image {
    display: block;
    width: 50%;
    place-items: center;
  }
  .image {
    height: 250px;
    width: 1350px;
  }
  </style>
  